module.exports = __webpack_public_path__ + "static/media/blonde_mobile.f7e32bce.png";